module.exports = __webpack_public_path__ + "assets/img/planTicket.0c8ea484.png";